export default {
  name: 'AvatarImage',

  props: {
    alt: {
      type: String,
      default: ''
    },

    src: {
      type: String,
      default: ''
    },

    stubTxt: {
      type: String,
      default: ''
    },

    width: {
      type: String | Number,
      default: 40
    },

    height: {
      type: String | Number,
      default: 40
    }
  },

  data() {
    return {
      error: false
    }
  },

  computed: {
    stubStr() {
      if (!this.stubTxt && this.alt) {
        const textArr = this.alt.split(' ')
        return textArr[textArr.length - 1].charAt(0).toUpperCase()
      }
      return this.stubTxt
    }
  },

  methods: {
    onError() {
      this.error = true
    }
  },

  watch: {
    src() {
      this.error = false
    }
  }
}